// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--NWwRB","icon":"icon--S_DAS","small":"small--wD_CS","disabled":"disabled--ZvV2r"};